import Glide, {
  Controls,
  Breakpoints,
  Autoplay,
  Swipe,
} from '@glidejs/glide/dist/glide.modular.esm'

class RecentlyViewedProducts extends HTMLElement {
  static get observedAttributes() {
    return [`slider-disabled`]
  }

  constructor() {
    super()
    this.renderProducts();
  }

  initSlider() {
    console.log('initSlider()')

    this.settings = {
      type: 'slider',
      perView: 4,
      peek: 0,
      startAt: 0,
      bound: false,
      gap: 0,
      breakpoints: {
        750: {
          perView: 1
        }
      },
    }

    if (this.querySelector('[glide-settings]') !== null) {
      this.settings = JSON.parse(
        this.querySelector('[glide-settings]').textContent
      )
    }

    this.carousel = new Glide(this, this.settings)
      .on('mount.after', () => {
        const images = [...this.querySelectorAll('.lazyload')]
        images.map((image) => {
          if (image.classList.contains('lazyload')) {
            const width = image.parentNode.offsetWidth
            image.src = image.dataset.src.replace('{width}', width)
          }
        })
      })
      .mount({ Controls, Breakpoints, Autoplay, Swipe })

  }


  renderProducts() {
    const data = JSON.parse(localStorage.getItem('sc-recently-viewed-products'))
    const recentlySection = this.closest('section')
    console.log('RV slider check');

    (data != null && (recentlySection.classList.remove('tw-hidden'), this.querySelector('.glide__slides').innerHTML = data
      .map((el) => {
        let price,
          title = el.title

        // PRICE
        if (el.compare_at_price_true) {
          price = `<li class="tw-text-[#EA4335] tw-text-xl tw-leading-[0.875rem]">${el.price}</li> 
                    <li class="tw-text-black tw-line-through tw-text-xltw-leading-[0.875rem]">${el.compare_at_price}</li>`
        } else {
          price = `<li class="tw-text-black tw-text-xl tw-leading-[0.875rem]">${el.price}</li>`
        }

        return `<div class="glide__slide">
                  <a href="${el.url}" class="tw-block tw-group/index" aria-label="${el.title}">
                    <div class="tw-relative tw-z-[-1] tw-group-hover/index:z-0">
                      <div class="tw-relative tw-z-[3] ${el.secondImage ? 'tw-group' : ''}">
                        <div class="tw-pb-[147.89%] mob:tw-pb-[147.76%] desSmall:tw-pb-[147.91%] tw-z-[-1] tw-media-wrapper tw-duration-300 tw-ease-in-out">
                          <img class="tw-duration-300 tw-ease-in-out tw-group-hover/index:opacity-0 tw-group-hover/index:invisible" src="${el.mainImage}" alt="${el.title} first image" loading="lazy" decoding="async" />
                          <img class="tw-duration-300 tw-ease-in-out tw-opacity-0 tw-invisible tw-group-hover/index:opacity-100 tw-group-hover/index:visible" src="${el.secondImage}" alt="${el.title} second image" loading="lazy" decoding="async" />
                        </div>
                      </div>
                      <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-pt-2.5 tw-mob:pt-4">
                        <div class="tw-flex tw-flex-col">
                          <span class="full-unstyled-link">
                            ${title} 
                          </span>
                          <!-- Price variants -->
                          <ul class="card-information">
                            ${price}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>`
      })
      .join('')
      ))
      this.initSlider()

      // if (data !== null) {
      //   const handleIntersection = (entries, observer) => {
      //     if (!entries[0].isIntersecting) return
      //     observer.unobserve(this)
      //     this.renderProducts(data)
      //   }
  
      //   new IntersectionObserver(handleIntersection.bind(this), {
      //     rootMargin: '0px 0px 200px 0px',
      //   }).observe(this)
  
      // } else {
      //   recentlySection.classList.add('tw-hidden')
      // }
  }
}

customElements.define('sc-recently-viewed-products', RecentlyViewedProducts)